// extracted by mini-css-extract-plugin
export default {"searchWrapper":"UserSearch_searchWrapper__cx91h","searchIcon":"UserSearch_searchIcon__L0V-I","searchInput":"UserSearch_searchInput__6F0Ot"};